import type { DemoShare } from '@carboncopyco/types';
import { Toggle, TooltipBubble } from '@carboncopyco/ui';
import { isFuture, useDemoAnalytics } from '@carboncopyco/utils';
import { useAllowedShareSecurityLevels } from '../../../Share/useAllowedShareSecurityLevels';
import { useDemoPageProps } from '../DemoPageContext';
import { disabledDueToSharingPolicyText } from './consts';

export const LinkToggle = ({
  link,
  onToggle,
}: {
  link: DemoShare;
  onToggle: (link: DemoShare) => void;
}) => {
  const { isActive, options, entityId } = link;
  const { organizationId } = useDemoPageProps();
  const { allowedDemoSecurityLevels } =
    useAllowedShareSecurityLevels(organizationId);
  const disabled = !allowedDemoSecurityLevels.includes(options.security.level);
  const checked =
    isActive && (!options.expiresAt || isFuture(options.expiresAt));
  const { trackDemoClickActivateShare, trackDemoClickDeactivateShare } =
    useDemoAnalytics('demo_info_page_shares_tab_table');

  function getTooltipLabel() {
    if (disabled) {
      return disabledDueToSharingPolicyText;
    }
    return checked ? 'Link is active' : 'Link is inactive';
  }

  return (
    <TooltipBubble
      title={getTooltipLabel()}
      placement="top"
      offset={[0, 10]}
    >
      <div
        className="mr-6"
        style={{ pointerEvents: 'all' }}
        aria-label="link toggle"
      />
      <Toggle
        checked={checked}
        onChange={() => {
          isActive
            ? trackDemoClickDeactivateShare({
                demoId: entityId,
              })
            : trackDemoClickActivateShare({
                demoId: entityId,
              });

          onToggle(link);
        }}
        disabled={disabled}
      />
    </TooltipBubble>
  );
};
